import "./App.css";
import { Blocks } from "./Containers/Blocks";
import { Footer } from "./Containers/Footer";
import { Header } from "./Containers/Header";
import "./firebase";

function App() {
    return (
        <div className="App">
            <Header />
            <Blocks />
            <Footer />
        </div>
    );
}

export default App;
